import {Component} from 'react'
import Cookies from 'js-cookie'
import {Redirect, Link} from 'react-router-dom'
import {IoMdClose} from 'react-icons/io'
import {GoSearch} from 'react-icons/go'

import AppContext from '../../context/AppContext'

import FailureView from '../FailureView'
import LoaderEl from '../Loader'
import SideBar from '../SideBar'
import Header from '../Header'

import {
  HomeVideosContainer,
  HomeInputContainer,
  HomeInputEl,
  HomeSearchButton,
  HomePageVideosList,
  HomeVideoItemCard,
  HomeThumbnailUrl,
  HomeVideoItemBottomContainer,
  HomeChannelLogo,
  HomeVideoItemTitleContainer,
  HomeVideoItemTitle,
  HomeVideoItemChannelName,
  HomeViewAndYearItems,
  HomeViews,
  HomeYear,
  HomeCard,
  BannerContainer,
  BannerHeaderContainer,
  BannerButtonIcon,
  WebLogo,
  BannerMatter,
  BannerButton,
  HomeNoResultsContainer,
  HomeNoResultsImg,
  HomeNoResultsHeading,
  HomeNoResultsPara,
  HomeNoResultsButton,
} from './styledComponents'

const apiStatusConstants = {
  initial: 'INITIAL',
  inProgress: 'IN PROGRESS',
  success: 'SUCCESS',
  failure: 'FAILURE',
}

class Home extends Component {
  state = {
    apiStatus: apiStatusConstants.initial,
    searchVal: '',
    homeVideosList: [],
  }

  componentDidMount() {
    this.homeApiCall()
  }

  onChangeSearchInput = event => {
    this.setState({searchVal: event.target.value})
  }

  onClickSearchButton = () => {
    this.homeApiCall()
  }

  homeApiCall = async () => {
    this.setState({apiStatus: apiStatusConstants.inProgress})
    const jwtToken = Cookies.get('jwt_token')
    const {searchVal} = this.state
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
    const url = `https://apis.ccbp.in/videos/all?search=${searchVal}`
    const response = await fetch(url, options)
    if (response.ok === true) {
      const data = await response.json()
      const formattedData = data.videos.map(each => ({
        id: each.id,
        title: each.title,
        thumbnailUrl: each.thumbnail_url,
        viewCount: each.view_count,
        publishedAt: each.published_at,
        channel: {
          name: each.channel.name,
          profileImageUrl: each.channel.profile_image_url,
        },
      }))
      this.setState({
        apiStatus: apiStatusConstants.success,
        homeVideosList: formattedData,
      })
      console.log(formattedData)
    } else {
      this.setState({apiStatus: apiStatusConstants.failure})
    }
  }

  renderSuccessView = () => {
    const {homeVideosList, searchVal} = this.state
    return (
      <AppContext.Consumer>
        {value => {
          const {theme, duration} = value
          return (
            <HomeVideosContainer theme={theme}>
              <HomeInputContainer theme={theme}>
                <HomeInputEl
                  type="search"
                  theme={theme}
                  placeholder="Search"
                  value={searchVal}
                  onChange={this.onChangeSearchInput}
                />
                <HomeSearchButton
                  data-testid="searchButton"
                  type="button"
                  theme={theme}
                  onClick={this.onClickSearchButton}
                >
                  <GoSearch />
                </HomeSearchButton>
              </HomeInputContainer>
              {homeVideosList.length === 0 ? (
                this.renderNoResultsView()
              ) : (
                <HomePageVideosList theme={theme}>
                  {homeVideosList.map(each => (
                    <HomeVideoItemCard
                      as={Link}
                      to={`/videos/${each.id}`}
                      key={each.id}
                      theme={theme}
                    >
                      <HomeThumbnailUrl
                        src={each.thumbnailUrl}
                        alt="video thumbnail"
                      />
                      <HomeVideoItemBottomContainer>
                        <HomeChannelLogo
                          src={each.channel.profileImageUrl}
                          alt="channel logo"
                        />
                        <HomeVideoItemTitleContainer>
                          <HomeVideoItemTitle theme={theme}>
                            {each.title}
                          </HomeVideoItemTitle>
                          <HomeVideoItemChannelName theme={theme}>
                            {each.channel.name}
                          </HomeVideoItemChannelName>
                          <HomeViewAndYearItems theme={theme}>
                            <HomeViews as="p" theme={theme}>
                              {each.viewCount} views
                            </HomeViews>
                            <HomeYear theme={theme}>
                              {each.publishedAt} {duration(each.publishedAt)}
                            </HomeYear>
                          </HomeViewAndYearItems>
                        </HomeVideoItemTitleContainer>
                      </HomeVideoItemBottomContainer>
                    </HomeVideoItemCard>
                  ))}
                </HomePageVideosList>
              )}
            </HomeVideosContainer>
          )
        }}
      </AppContext.Consumer>
    )
  }

  renderNoResultsView = () => (
    <AppContext.Consumer>
      {value => {
        const {theme} = value
        return (
          <HomeNoResultsContainer>
            <HomeNoResultsImg
              src="https://assets.ccbp.in/frontend/react-js/nxt-watch-no-search-results-img.png"
              alt="no videos"
            />
            <HomeNoResultsHeading theme={theme}>
              No Search results found
            </HomeNoResultsHeading>
            <HomeNoResultsPara theme={theme}>
              Try different key words or remove search filter
            </HomeNoResultsPara>
            <HomeNoResultsButton
              theme={theme}
              onClick={this.onClickSearchButton}
            >
              Retry
            </HomeNoResultsButton>
          </HomeNoResultsContainer>
        )
      }}
    </AppContext.Consumer>
  )

  render() {
    const {apiStatus} = this.state
    const JwtToken = Cookies.get('jwt_token')
    if (JwtToken === undefined) {
      return <Redirect to="/login" />
    }
    const {match} = this.props
    const {path} = match
    return (
      <>
        <Header />
        <SideBar path={path} />

        <AppContext.Consumer>
          {value => {
            const {isBannerVisible, theme, onClickToggleBanner} = value
            const onCickBannerButton = () => {
              onClickToggleBanner()
            }
            return (
              <HomeCard data-testid="home" theme={theme}>
                {isBannerVisible && (
                  <BannerContainer data-testid="banner">
                    <BannerHeaderContainer>
                      <WebLogo
                        src="https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png"
                        alt="nxt watch logo"
                      />
                      <BannerButtonIcon
                        data-testid="close"
                        type="button"
                        onClick={onCickBannerButton}
                      >
                        <IoMdClose />
                      </BannerButtonIcon>
                    </BannerHeaderContainer>
                    <BannerMatter>
                      Buy Nxt Watch Premium prepaid plans with UPI
                    </BannerMatter>
                    <BannerButton>GET IT NOW</BannerButton>
                  </BannerContainer>
                )}
                {(() => {
                  switch (apiStatus) {
                    case apiStatusConstants.inProgress:
                      return <LoaderEl />
                    case apiStatusConstants.failure:
                      return (
                        <FailureView
                          onClickSearchButton={this.onClickSearchButton}
                          path={path}
                        />
                      )
                    case apiStatusConstants.success:
                      return this.renderSuccessView()
                    default:
                      return null
                  }
                })()}
              </HomeCard>
            )
          }}
        </AppContext.Consumer>
      </>
    )
  }
}

export default Home
